import WidgetPanel from './widget-panel';

export default WidgetPanel;
